module.exports = __webpack_public_path__ + "static/img/c_img_2.01e83ae5.png";